import TagAPI from "./TagAPI";

const TagApiClient = new TagAPI();

export default TagApiClient;